import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/navigation';

const articles = [
  {
    id: 'guide',
    title: 'VigorBuy Spreadsheet: The Complete Guide for Beginners &amp; Experts',
    excerpt: 'Master everything about VigorBuy Spreadsheet from basic setup to advanced features. Covers templates, automation, data management, and expert productivity tips.',
    category: 'Ultimate Guide',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20minimal%20desk%20setup%20with%20a%20laptop%20displaying%20a%20clean%20spreadsheet%20dashboard%2C%20soft%20natural%20lighting%20from%20a%20window%2C%20a%20stylish%20ceramic%20coffee%20cup%20beside%20the%20laptop%2C%20cream%20and%20beige%20workspace%20tones%2C%20editorial%20productivity%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=500&seq=article-card-guide-v2&orientation=landscape',
    link: '/vigorbuy-spreadsheet-guide',
  },
  {
    id: 'review',
    title: 'VigorBuy Spreadsheet Review 2026: Honest Features &amp; Benefits Analysis',
    excerpt: 'In-depth unbiased review after 40+ hours of testing. Covers smart formula engine, visual automation, real-time collaboration, pricing, pros and cons.',
    category: 'Review',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20desk%20with%20a%20laptop%20showing%20a%20product%20review%20dashboard%20with%20star%20ratings%20on%20screen%2C%20warm%20natural%20window%20side%20lighting%2C%20minimalist%20workspace%20with%20a%20notebook%20and%20pen%2C%20soft%20cream%20background%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-card-review-v2&orientation=landscape',
    link: '/vigorbuy-spreadsheet-review',
  },
  {
    id: 'templates',
    title: 'VigorBuy Spreadsheet Templates: 200+ Ready-to-Use Resource Guide',
    excerpt: 'Complete catalog of templates for business finance, inventory, project management, sales CRM, and personal productivity. Customization tips included.',
    category: 'Templates',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20colorful%20spreadsheet%20template%20printouts%20spread%20across%20a%20warm%20wooden%20desk%20surface%2C%20soft%20natural%20window%20light%2C%20organized%20creative%20workspace%20aesthetic%2C%20charts%20and%20grids%20visible%20on%20paper%2C%20warm%20cream%20tones%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-card-templates-v2&orientation=landscape',
    link: '/vigorbuy-spreadsheet-templates',
  },
  {
    id: 'security',
    title: 'Is VigorBuy Spreadsheet Safe? Complete Security &amp; Privacy Analysis',
    excerpt: 'Deep dive into encryption standards, authentication protocols, access controls, GDPR compliance, and essential security best practices for users.',
    category: 'Security',
    readTime: '9 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20glowing%20digital%20padlock%20icon%20floating%20above%20a%20laptop%20screen%20on%20a%20clean%20modern%20desk%2C%20soft%20warm%20ambient%20lighting%2C%20subtle%20shield%20graphics%20on%20screen%2C%20cybersecurity%20concept%2C%20warm%20cream%20and%20gray%20tones%2C%20professional%20aesthetic%2C%20high%20detail&width=800&height=500&seq=article-card-security-v2&orientation=landscape',
    link: '/vigorbuy-spreadsheet-security',
  },
  {
    id: 'comparison',
    title: 'VigorBuy Spreadsheet vs Excel vs Google Sheets: Full Comparison 2026',
    excerpt: 'Head-to-head comparison across 10 dimensions: pricing, templates, automation, collaboration, security, integrations, mobile, and overall value.',
    category: 'Comparison',
    readTime: '13 min read',
    image: 'https://readdy.ai/api/search-image?query=Three%20different%20spreadsheet%20interface%20screens%20displayed%20side%20by%20side%20on%20a%20clean%20modern%20desk%2C%20comparison%20concept%20visualization%2C%20warm%20natural%20lighting%2C%20professional%20office%20setup%2C%20soft%20cream%20and%20beige%20background%2C%20editorial%20tech%20photography%2C%20high%20detail&width=800&height=500&seq=article-card-comparison-v2&orientation=landscape',
    link: '/vigorbuy-spreadsheet-comparison',
  },
  {
    id: 'beginners',
    title: 'Getting Started with VigorBuy Spreadsheet: A Step-by-Step Beginner Guide',
    excerpt: 'New to VigorBuy Spreadsheet? This friendly guide walks you through account setup, first spreadsheet creation, basic formulas, and essential tips.',
    category: 'Beginner',
    readTime: '8 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20welcoming%20desk%20scene%20with%20a%20laptop%20showing%20a%20simple%20welcome%20tutorial%20screen%2C%20a%20fresh%20potted%20plant%20beside%20the%20laptop%2C%20warm%20morning%20sunlight%20streaming%20through%20a%20window%2C%20cream%20and%20beige%20minimalist%20workspace%2C%20inviting%20beginner%20friendly%20atmosphere%2C%20high%20detail&width=800&height=500&seq=article-card-beginner-01&orientation=landscape',
    link: '/vigorbuy-spreadsheet-guide',
  },
  {
    id: 'tips',
    title: '15 Best VigorBuy Spreadsheet Tips &amp; Tricks for Better Productivity',
    excerpt: 'Power user secrets revealed. Keyboard shortcuts, hidden features, formula tricks, and workflow optimizations to save hours every week.',
    category: 'Tips & Tricks',
    readTime: '10 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20workspace%20with%20a%20laptop%20displaying%20spreadsheet%20with%20highlighted%20tips%20and%20shortcut%20overlays%2C%20warm%20natural%20side%20lighting%2C%20organized%20desk%20with%20sticky%20notes%2C%20cream%20and%20beige%20tones%2C%20productive%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=article-card-tips-01&orientation=landscape',
    link: '/vigorbuy-spreadsheet-guide',
  },
  {
    id: 'business',
    title: 'VigorBuy Spreadsheet for Small Business: Complete Operations Guide',
    excerpt: 'How small businesses use VigorBuy Spreadsheet for inventory tracking, invoicing, payroll, customer management, and financial forecasting.',
    category: 'Business',
    readTime: '11 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20business%20owner%20desk%20with%20a%20laptop%20showing%20a%20business%20dashboard%20spreadsheet%2C%20warm%20natural%20lighting%2C%20organized%20workspace%20with%20coffee%20and%20planner%2C%20cream%20and%20beige%20professional%20tones%2C%20entrepreneurial%20atmosphere%2C%20high%20detail&width=800&height=500&seq=article-card-business-01&orientation=landscape',
    link: '/vigorbuy-spreadsheet-guide',
  },
  {
    id: 'automation',
    title: 'Mastering VigorBuy Spreadsheet Automation: From Basics to Advanced Workflows',
    excerpt: 'Everything about the visual automation builder. Learn triggers, actions, conditional logic, scheduling, and real-world automation examples.',
    category: 'Automation',
    readTime: '12 min read',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20workspace%20with%20a%20laptop%20showing%20a%20workflow%20automation%20diagram%20on%20screen%2C%20soft%20warm%20natural%20lighting%2C%20clean%20organized%20desk%20with%20a%20mechanical%20keyboard%2C%20cream%20and%20beige%20tones%2C%20tech%20productivity%20aesthetic%2C%20high%20detail&width=800&height=500&seq=article-card-automation-01&orientation=landscape',
    link: '/vigorbuy-spreadsheet-guide',
  },
];

export default function ArticleSection() {
  return (
    <section id="articles" className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-article-line"></i>
            Expert Content
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            Featured Guides &amp; Articles
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive deep into our expertly crafted guides. Each article is written to provide
            genuine value and help you get the most out of VigorBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={article.link}
              onClick={() => window.scrollTo(0, 0)}
              className="group flex flex-col rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-4 text-sm font-medium text-primary-600">
                  Read Article
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-14 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60">
            <div className="text-left">
              <h3 className="font-heading text-lg text-foreground-900 mb-1">
                Ready to Start Shopping?
              </h3>
              <p className="text-sm text-foreground-600">
                Visit the main VigorBuy Spreadsheet store and explore all products.
              </p>
            </div>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 px-7 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}